import { KeyboardEvent, SyntheticEvent } from 'react';

type KeyboardEventHandlerWithArg<T, R> = (event: KeyboardEvent, arg?: T) => R;

export const keyPressHelper = <T = any, R = void>(callback: (arg?: T, e?: SyntheticEvent) => R): KeyboardEventHandlerWithArg<T, R> => (e, arg?): R => {
  if (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ') {
    e.preventDefault();
    return callback(arg, e);
  }

  return undefined;
};
